











































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faUniversalAccess } from '@fortawesome/free-solid-svg-icons';
import APSList from '@/components/APSList.vue';
import { ApsDataService } from '@/services/ApsDataService';
import APSLocation from '@/entities/APSLocation';

library.add(faUniversalAccess as IconDefinition);

@Component({
  components: {
    APSList,
  },
})
export default class AuditoryPedestrianSignal extends Vue {
  private locations: APSLocation[] = ApsDataService.data;
  private onlyAODA: boolean = false;
  private locationFilter: string = '';
  private searchLocation = false;
  private getFilteredLocations: APSLocation[] = [];
  private labels: string[] = [];
  private links: string[] = [];

  public get locale(): string {
    return this.$i18n.locale;
  }

  @Watch('locale')
  public onLocaleChange(value: string, oldVal: string) {
    this.setPageHead();
    this.setBreadcrumbs();
  }

  private get filteredLocations(): APSLocation[] {
    let fl = this.locations;
    // Filter to only the accessible locations.
    if (this.onlyAODA) {
      fl = this.locations.filter((location) => {
        return location.aoda;
      });
    }
    // Filter by street name.
    if (this.locationFilter.trim().length > 0) {
      return fl.filter((location) => {
        if (this.$i18n.locale === 'fr') {
          return (
            location.fr
              .toLowerCase()
              .indexOf(this.locationFilter.toLowerCase()) >= 0
          );
        }
        return (
          location.en
            .toLowerCase()
            .indexOf(this.locationFilter.toLowerCase()) >= 0
        );
      });
    }
    return fl;
  }

  public mounted() {
    const preCheckAoda = this.$route.query.aoda;
    if (typeof preCheckAoda === 'string' && parseInt(preCheckAoda, 10) === 1) {
      this.onlyAODA = true;
    }
    this.setPageHead();
    this.setBreadcrumbs();
  }

  public setBreadcrumbs() {
    this.labels = [
      this.$t('homeTitle').toString(),
      this.$t('parkingTitle').toString(),
      this.$t('trafficTitle').toString(),
      this.$t('signalsTitle').toString(),
      this.$t('APSTitle').toString(),
    ];
    this.links = [
      this.$t('homeUrl').toString(),
      this.$t('parkingUrl').toString(),
      this.$t('trafficUrl').toString(),
      this.$t('signsUrl').toString(),
    ];
    this.$store.commit('setLabels', this.labels);
    this.$store.commit('setLinks', this.links);
  }

  public setPageHead() {
    if (this.$el.ownerDocument !== null) {
      this.$el.ownerDocument.title = this.$t('pageTitle').toString();
    }
  }

  public getSearchLocation() {
    this.searchLocation = true;
    this.getFilteredLocations = this.filteredLocations;
  }
}
